<template>
  <v-container fluid>
    <h1>{{ $t('satisfaction_survey_report') }}</h1>
    <v-layout wrap>
      <v-flex xs8>
        <v-chip label disabled color="#0085FF" class="white--text">{{ currentDateFilter }}</v-chip>
      </v-flex>
      <v-flex xs4 justify-end style="display: flex">
        <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
          <v-icon>search</v-icon>
          <span class="px-1">{{ $t('advanced search') }}</span>
          <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
          <em v-else class="fas fa-angle-up" />
        </v-btn>
      </v-flex>
      <v-flex v-if="showAdvancedSearch" xs12>
        <AdvanceSearch
          :filters="filters"
          :intent-raw-data="intentFilterData"
          @onSearch="handleSearch"
          @onClearSearch="handleClearSearch"
        />
      </v-flex>
    </v-layout>
    <div>
      <DataTable :filters="filters" />
    </div>
  </v-container>
</template>

<script>
import generaliApi from '@/api/generali'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import AdvanceSearch from './AdvanceSearch.vue'
import DataTable from './DataTable.vue'

export default {
  components: {
    AdvanceSearch,
    DataTable
  },
  data() {
    return {
      filters: {
        intent: '',
        start_date: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD')
      },
      showAdvancedSearch: false,
      exportLoading: false,
      intentFilterData: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    currentDateFilter() {
      const startDate = dayjs(this.filters.start_date).format('DD/MM/YYYY')
      const endDate = dayjs(this.filters.end_date).format('DD/MM/YYYY')
      return `${startDate} - ${endDate}`
    }
  },
  mounted() {
    this.handleGetIntentFilter()
  },
  methods: {
    handleSearch(value) {
      if (value) {
        this.filters = {
          intent: value.intent || '',
          start_date: value.start_date || '',
          end_date: value.end_date || ''
        }
      }
    },
    handleClearSearch() {
      this.filters = {
        intent: '',
        start_date: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD')
      }
    },
    async handleGetIntentFilter() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: 999,
          offset: 0
        }

        vm.$store.dispatch('loading')
        const response = await generaliApi.getIntentFilter({
          config: {
            params: data
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          const responseData = response.data.data
          vm.intentFilterData = responseData
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/index.vue